import { Impact, TileVariant, Tree } from "@ecologi/shared";
import styled from "@emotion/styled";
import React from "react";
import { getImageOrAnimation } from ".";
import {
  ForestTile,
  ForestTileAnimation,
  ForestTileInner,
  ForestTilePopover,
} from "../ForestTile";
import { ImpactFundTileBadge } from "../ImpactFundTileBadge";

export type ForestTileImpactProps = {
  impact: Exclude<Impact, Tree>;
  isLinkedTile?: boolean;
  isNudged: boolean;
  numbering: number;
  onClick: () => void;
};

const ForestTileBase = styled(ForestTile)`
  cursor: pointer;
`;

const AnimationWrapper = styled.div`
  @media (min-width: ${({ theme }) => theme.bp.breakTablet}) {
    margin: -12px;
  }
`;

const Image = styled.img`
  width: 100%;
  height: 100%;
`;

export const ForestTileImpact = ({
  impact,
  isLinkedTile,
  isNudged,
  numbering,
  onClick,
}: ForestTileImpactProps) => {
  const imageOrAnimation = getImageOrAnimation(impact.project);

  return (
    <ForestTileBase
      id={isLinkedTile ? impact._id : ""}
      isNudged={isNudged}
      onClick={onClick}
      title={impact.project?.title}
      $isCentered={numbering === 1}
      data-testid="tile"
    >
      <ForestTileInner>
        {impact.variant === TileVariant.IMPACT_FUND && (
          <ImpactFundTileBadge data-testid="tile-impact-fund-badge" />
        )}

        {imageOrAnimation?.type === "image" && (
          <Image
            src={imageOrAnimation.path}
            alt={`Illustration of ${impact.project?.title} project`}
            loading="lazy"
            data-testid={`forest-tile-${impact.project?.impactType}-image`}
          />
        )}
        {imageOrAnimation?.type === "animation" && (
          <AnimationWrapper
            data-testid={`forest-tile-${impact.project?.impactType}-animation`}
          >
            <ForestTileAnimation
              animation={imageOrAnimation.animation}
              randomStart={imageOrAnimation.randomStart}
            />
          </AnimationWrapper>
        )}
        {isLinkedTile && (
          <ForestTilePopover
            data-testid="forest-tile-popover"
            message={`Your project`}
          />
        )}
      </ForestTileInner>
    </ForestTileBase>
  );
};
